import { render, staticRenderFns } from "./input-regular.vue?vue&type=template&id=1cf71356"
import script from "./input-regular.vue?vue&type=script&lang=js"
export * from "./input-regular.vue?vue&type=script&lang=js"
import style0 from "./input-regular.vue?vue&type=style&index=0&id=1cf71356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports